
define('jsx!components/modal/duplicate-buncee',["react", "shared/user"], function(React, User)
{
    return React.createClass({
        displayName: "DuplicateBunceeModal",
        response: undefined,
        getInitialState: function ()
        {
            return {
                request_status: null
            }
        },
        componentWillMount: function ()
        {
            /*
             * Trigger the request to duplicate the buncee
             */
            if ((window.api || window.appData) && this.props.buncee_guid) {
                var self = this;
                var promise;
                if (window.api) {
                    promise = window.api.request("buncees", this.props.buncee_guid, "duplicate").create({});
                } else if (window.appData && this.props.url){
                    promise = $.ajax({
                        url: window.appData.client.api_url + "/buncees/duplicate?url=" +this.props.url,
                        type: 'POST',
                        data: {
                            access_token: window.appData.user.access_token,
                        },
                        headers: {
                            'Authorization': "Bearer " + window.appData.user.access_token,
                        },
                        dataType: 'json',
                    });
                }
                this.setState({
                    request_status: "in_progress"
                });
                
                promise.done(function (response)
                {   
                    self.setState({
                        request_status: "successful"
                    });
                    if (typeof self.props.trackIdea === 'function') {
                        self.props.trackIdea();
                    }
                    self.response = response;
                });

                promise.fail(function (jqXHR)
                {
                    if(jqXHR.status == 423) {
                        self.setState({
                            request_status: "locked"
                        })
                    } else {
                        self.setState({
                            request_status: "failed"
                        });
                    }
                    self.response = this.response;
                });

                if (this.props.idea_guid) {

                }
            }
        },
        componentDidMount: function () 
        {
            var self = this;
            if ((!window.appData && !window.api) || !this.props.buncee_guid) {
                setTimeout(function ()
                {
                    self.close();
                }, 0);
            }
        },
        close: function ()
        {
            var parent = document.getElementById('buncee-modal');
            React.unmountComponentAtNode(parent);
        },
        handleClickOnCloseButton: function ()
        {
            this.close();
        },
        handleClickOnViewButton: function ()
        {
            window.open(this.response.links.view, '_blank');
        },
        handleClickOnEditButton: function ()
        {
            window.open(this.response.links.edit, '_blank');
        },
        handleClickOnUpgrade: function() {
            window.location.href = "/links/billing";
        },
        renderStockModal: function (title, body, buttons)
        {
            return (
                React.createElement("div", null, 
                    React.createElement("div", {className: "buncee-modal"}, 
                        React.createElement("div", {className: "buncee-modal-title"}, title), 
                        React.createElement("div", {className: "buncee-modal-action"}, body), 
                        React.createElement("div", {className: "buncee-modal-buttons"}, buttons)
                    ), 
                    React.createElement("div", {id: "overlay"})
                )
            );
        },
        renderRequestInProgress: function ()
        {
            return this.renderStockModal("Copying buncee...", null, null);
        },
        renderRequestSuccessful: function ()
        {
            var buttons = [
                React.createElement("div", {className: "modal-button buncee", onClick: this.handleClickOnEditButton}, "Edit"),
                React.createElement("div", {className: "modal-button button-blue", onClick: this.handleClickOnViewButton}, "View"),
                React.createElement("div", {className: "modal-button button-red", onClick: this.handleClickOnCloseButton}, "Close")
            ];
            return this.renderStockModal('Copied!', "What would you like to do next?", buttons);
        },
        renderRequestFailed: function ()
        {
            var button = React.createElement("div", {className: "modal-button buncee", onClick: this.handleClickOnCloseButton}, "Close");
            return this.renderStockModal('Failed!', 'The buncee could not be copied at this time.', button);
        },
        renderRequestLocked: function() {
            var buttons = [
                React.createElement("div", {className: "modal-button button-color-cool", onClick: this.handleClickOnUpgrade}, "Upgrade"),
                React.createElement("div", {className: "modal-button buncee", onClick: this.handleClickOnCloseButton}, "Close")
            ];
            return this.renderStockModal(
                'Wowza!', 
                React.createElement("div", {style: {textAlign:'center', fontSize:'14px', padding:'20px 20px'}}, 
                    React.createElement("img", {style: {width:'100%', margin:'10px'}, src: "/dist/images/buncees-limit-reached.png"}), 
                    "You've been so busy Buncee\'ing that you've reached your limit of " + User.getSetting('creation.max_buncees') 
                        + " free Buncees. Please upgrade your account to keep creating new Buncees and take advantage of our premium features."
                ), 
                buttons);
        },
        render: function ()
        {
            if (this.state.request_status == "in_progress") {
                return this.renderRequestInProgress();
            } else if (this.state.request_status == "successful") {
                return this.renderRequestSuccessful();
            } else if (this.state.request_status == "failed") {
                return this.renderRequestFailed();
            } else if (this.state.request_status == "locked") {
                return this.renderRequestLocked();
            }
        }
    });
});
